import Image from 'next/image';
import { useRouter } from 'next/router';
import { useState } from 'react';
import styled from 'styled-components';
interface IProps {
  header: string;
  subHeader: string;
  content: any;
  faqRef?: any;
  contact?: boolean | undefined;
}
const ContentStyle = styled.p`
  animation: slowDown 500ms linear forwards;
  @keyframes slowDown {
    0% {
      transform: scaleY(0);
    }
    80% {
      transform: scaleY(1.1);
    }
    100% {
      transform: scaleY(1);
    }
  }
`;

const Faqs = ({ header, subHeader, content, faqRef, contact }: IProps) => {
  function renderContentWithBullets(htmlString: string) {
    const liRegex = /<li>(.*?)<\/li>/g;

    const parts = htmlString?.split(liRegex);

    return parts.map((part, index) => {
      if (index % 2 === 0) {
        return <span key={index} dangerouslySetInnerHTML={{ __html: part }} />;
      }
      return (
        <div key={index} className="flex items-start mb-2">
          <Image
            src="/bullet-point.png"
            alt="bullet icon"
            width={12}
            height={12}
            className="mr-3 mt-1.5"
          />
          <span className="text-[14px] sm:text-[14px] lg:text-[20px] font-[400]">
            {part}
          </span>
        </div>
      );
    });
  }
  const [toggleFaq, setToggleFaq] = useState<boolean[]>(
    content?.map(() => false)
  );
  const handleToggleFaq = (index: number) => {
    setToggleFaq(prev =>
      prev?.map((value, i) => (i === index ? !value : false))
    );
  };
  const router = useRouter();
  const isExplorePage = router?.asPath?.includes('/explore');
  return (
    <div id="faqs" ref={faqRef} className="w-full">
      <h2
        className={` w-full md:w-full mx-auto ${
          isExplorePage
            ? 'text-[22px] md:text-[32px] xl:text-[36px] font-[700] text-primary'
            : 'text-[18px] sm:text-2xl lg:text-4xl font-[500] lg:font-[600] text-[#333333]'
        }`}
      >
        {header}
      </h2>
      <h4
        className={`text-[16px] sm:text-[18px] lg:text-[24px] font-[400] text-[#333333] ${
          contact ? 'w-[90%]' : 'w-full'
        } md:w-full mx-auto mb-6 mt-3`}
      >
        {subHeader}
      </h4>
      {content?.map((section: Record<string, any>, index: number) => (
        <div
          id={`faq`}
          key={index}
          className="bg-[#F5F5F5] rounded-[10px] mb-3 p-3"
        >
          <div
            className="flex justify-between items-start hover:cursor-pointer"
            onClick={() => handleToggleFaq(index)}
          >
            <p className="text-[14px] sm:text-[16px] lg:text-[20px] font-semibold mb-3 pr-5">
              {Object.keys(section)[0]}
            </p>
            <div className="hover:cursor-pointer transition-transform duration-500">
              <Image
                src="/dropdownBlack_icon.svg"
                width={25}
                height={25}
                alt="dropdown icon"
                className={`transition-transform duration-500 min-w-[25px] w-[25px] sm:w-[30px] ${
                  toggleFaq[index] ? 'rotate-0' : 'rotate-180'
                }`}
              />
            </div>
          </div>

          {toggleFaq[index] && (
            <ContentStyle
              id={`faq-ans-${index}`}
              className="text-[12px] sm:text-[14px] lg:text-[20px] font-[400]"
            >
              {renderContentWithBullets(Object.values(section)[0])}
            </ContentStyle>
          )}
        </div>
      ))}
    </div>
  );
};

export default Faqs;
